import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import reduxPromise from "redux-promise-middleware";
import { routerMiddleware } from "react-router-redux";
import rootReducer from "./reducers";

const configureStore = (prelodedState, history) => {
  const middlewares = [reduxPromise(), thunk, routerMiddleware(history)];

  if (process.env.NODE_ENV === "development") {
    middlewares.push(createLogger());
  }

  const composed = [applyMiddleware(...middlewares)];

  if (process.env.NODE_ENV === "development") {
    const devExtension =
      window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__();
    if (devExtension) {
      composed.push(devExtension);
    }
  }

  const store = createStore(rootReducer, prelodedState, compose(...composed));

  // if (process.env.NODE_ENV === "development" && module.hot) {
  //   module.hot.accept("./modules", () => {
  //     const nextRootReducer = require("./modules").default;
  //     store.replaceReducer(nextRootReducer);
  //   });
  // }

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/index.js